import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '@/components/base/Icon';
import { gettext } from '@/utils/langsBook';
import toasty from '@/components/base/Toast';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var AddressHeader = function(props) {
    var ref, ref1;
    var router = useRouter();
    var children = props.children, childTitle = props.childTitle, childExtra = props.childExtra;
    var address = String(((ref = router.query) === null || ref === void 0 ? void 0 : ref.address) || ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.symbol));
    var ref2 = _slicedToArray(address.split(':'), 2), addressStr = ref2[0], addressType = ref2[1];
    var addressTypeTitle = useMemo(function() {
        switch(addressType){
            case 'token':
                return 'Token';
            case 'nft':
                return 'NFT';
            case 'dapp':
                return 'DApp';
            default:
                return 'User';
        }
    }, [
        addressType
    ]);
    var handleCopy = useCallback(function() {
        toasty({
            content: 'Copied'
        });
    }, []);
    var handleGoBack = useCallback(function() {
        router.back();
    }, [
        router
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        className: "my-[24px] overflow-hidden",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-[25px] flex items-center",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "text-[22px] font-inter-semibold leading-[29px]",
                        children: [
                            addressTypeTitle,
                            "\xa0",
                            [
                                'DApp',
                                'Token'
                            ].includes(addressTypeTitle) ? '' : gettext('Address'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "ml-[16px] text-[20px] font-mono",
                        children: addressStr
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc h-[21px] inline-flex bg-[#E5E6EB] rounded-[4px] px-[6px] ml-[8px] mr-[12px] text-[15px] items-center justify-center ",
                        children: addressType
                    }),
                    /*#__PURE__*/ _jsx(CopyToClipboard, {
                        text: address,
                        onCopy: handleCopy,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            type: "copy",
                            className: "cursor-pointer text-[16px]"
                        })
                    })
                ]
            }),
            childTitle && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center w-full mb-[13px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "left",
                        className: "text-primary text-[24px] mr-[6px]",
                        onClick: handleGoBack
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-[18px] font-semibold leading-[22px]",
                        children: gettext(childTitle)
                    }),
                    childExtra && /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1 text-desc text-right align-middle",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "bar",
                                className: "mr-[8px] align-middle"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "align-middle text-[14px] text-desc",
                                children: childExtra
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    }));
};
export default AddressHeader;
